import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/lib/toastDedupe";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import BusinessDetail from "@/pages/BusinessDetail";
import GuideView from "@/pages/GuideView";
import PublicReport from "@/pages/PublicReport";
import PublicClientReport from "@/pages/PublicClientReport";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";
import WhatsNew from "@/pages/WhatsNew";
import InvoiceView from "@/pages/InvoiceView";
import About from "@/pages/About";
import Formation from "@/pages/Formation";
import ClientPortal from "@/pages/ClientPortal";
import PublicBooking from "@/pages/PublicBooking";
import PublicBookingManage from "@/pages/PublicBookingManage";
import PublicWaitlistClaim from "@/pages/PublicWaitlistClaim";
import Settings from "@/pages/Settings";
import ReceiptRules from "@/pages/ReceiptRules";
import { FeedbackWidget } from "@/components/FeedbackWidget";

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bk-page)" }}>
        <div className="font-display text-2xl" style={{ color: "var(--bk-accent)" }}>Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/report/:shareId" element={<PublicReport />} />
            <Route path="/client-report/:shareId" element={<PublicClientReport />} />
            <Route path="/whats-new" element={<WhatsNew />} />
            <Route path="/about" element={<About />} />
            <Route path="/i/:publicId" element={<InvoiceView />} />
            <Route path="/portal/:slug" element={<ClientPortal />} />
            <Route path="/book/:slug" element={<PublicBooking />} />
            <Route path="/book/:slug/manage/:bookingId" element={<PublicBookingManage />} />
            <Route path="/book/:slug/claim/:waitlistId" element={<PublicWaitlistClaim />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/formation" element={<ProtectedRoute><Formation /></ProtectedRoute>} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/receipt-rules" element={<ProtectedRoute><ReceiptRules /></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/business/:id" element={<ProtectedRoute><BusinessDetail /></ProtectedRoute>} />
            <Route path="/guide/:phase" element={<ProtectedRoute><GuideView /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <FeedbackWidget />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
